import React from 'react';
import Icon from '../AppIcon';
import { cn } from '../../utils/cn';
import { useFavoriteModels } from '../../context/FavoriteModelsContext';

/**
 * Star toggle for model favorites. Must be used inside FavoriteModelsProvider.
 */
const FavoriteStarButton = ({ type, id, className, size = 16 }) => {
  const { isFavorite, toggleFavorite, isSaving } = useFavoriteModels();
  const active = isFavorite(type, id);

  return (
    <button
      type="button"
      disabled={isSaving || !id}
      aria-label={active ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
      aria-pressed={active}
      title={active ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
      onClick={(event) => {
        event.stopPropagation();
        toggleFavorite(type, id);
      }}
      className={cn(
        'inline-flex items-center justify-center rounded-lg p-2 transition-smooth',
        'hover:bg-primary/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        (isSaving || !id) && 'opacity-50 pointer-events-none',
        className
      )}
    >
      <Icon
        name="Star"
        size={size}
        className={cn(
          active ? 'text-amber-500 fill-amber-500' : 'text-muted-foreground'
        )}
        fill={active ? 'currentColor' : 'none'}
      />
    </button>
  );
};

export default FavoriteStarButton;
